(() => {
  var hamburgerDrawer = document.querySelector('.js-hamburger-drawer');
  var hamburgerOpenBtn = document.querySelector('.js-hamburger-open');
  // ハンバーガーアイコンをクリックした時にメニューを開く
  hamburgerOpenBtn.addEventListener('click', () => {
    hamburgerDrawer.classList.add('open')
  })

  // ドロワーメニューの外側をクリックした時にメニューを閉じる
  hamburgerDrawer.addEventListener('click', (e) => {
    if(!e.target.closest('.js-hamburger-drawrer-inner')) {
      hamburgerDrawer.classList.remove('open')
    }
  })
})();